import { render, staticRenderFns } from "./TbFilaAndamento.vue?vue&type=template&id=62fc5664&scoped=true"
import script from "./TbFilaAndamento.vue?vue&type=script&lang=js"
export * from "./TbFilaAndamento.vue?vue&type=script&lang=js"
import style0 from "./TbFilaAndamento.vue?vue&type=style&index=0&id=62fc5664&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62fc5664",
  null
  
)

export default component.exports